import { createFileRoute } from '@tanstack/react-router';
import { ReasonsLayout } from '../../layouts/Reasons/ReasonsLayout';

export const Route = createFileRoute('/$retailer/reasons')({
  component: ReasonsLayout,
});
